import MemberProfileList from './MemberProfileList';
export default MemberProfileList;
